import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=0a19e850"
import script from "./EditCompany.vue?vue&type=script&lang=js"
export * from "./EditCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports